import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import * as conf from "../config/common"

function AddDeclaration() {

  return (
    <>
      <li>
      I understand that my acceptance of the Scholarship is upon receiving the Scholarship offer letter issued by Sunway University/Sunway College (KL).
      </li><li>
      I have read and agree to abide by the Scholarship’s terms and conditions stipulated in the attached Scholarship brochure, with full understanding that the Scholarship will be withdrawn should any of the terms and conditions be broken.
      </li>
    </>        
  )

}

export default function Declaration() {

  let app = ApplicantContainer.useContainer();

    return (
      <>
      <Form.Row>     
        <Col xs={12}>          
          
          <Form.Check type="checkbox" id="frDeclarations">
          <Form.Check.Input className="frDeclarations-checkbox" type="checkbox" required checked={app.inStdValues.frDeclarations} onChange={e => app.onChangeInStdValues({...app.inStdValues, [e.target.id]:e.target.checked})}/>
          <Form.Check.Label className="frDeclarations-label"><h6>DECLARATION <small>(Please check to indicate that you agree with the above declaration)</small></h6></Form.Check.Label>         
          </Form.Check>          
        </Col>        
      </Form.Row>
      <Form.Row>
        <Col xs={12}>
          <Form.Group as={Col} controlId="frDeclarations">
                            
              <Form.Text className="declaration">     
              <ol>     
                <li>      
                  I have read the Personal Data Protection Notice provided by Sunway University/Sunway College pursuant to section 7 of Personal Data Protection Act 2010 (http://sunway.edu.my/pdpa/notice_english), which includes the purposes for which my personal data is collected/processed and classes of third parties to whom Sunway University/Sunway College may disclose my personal data to.
                </li><li>
                  I hereby give consent to Sunway University/Sunway College to process my personal data in accordance with the Personal Data Protection Notice.
                </li><li>
                  I also hereby warrant that I have obtained all necessary consent from the third party where I have provided their personal information as part of my application.
                </li><li>
                  I consent to any educational institution at which I have previously been a student and/or my current or any past employer, providing Sunway University/Sunway College with information which they hold about me for the purpose of Sunway University/Sunway College verifying my grades and/or qualification and experience.
                </li><li>
                  I authorise Sunway University/Sunway College to release fee and academic progress information to co-sponsor of the scholarship (if any).
                </li><li>
                  I declare that the information contained in this application form and in the attached documents are true and accurate to the best of my knowledge at this time. I acknowledge that Sunway University/Sunway College reserves the right to seek from other relevant bodies verification as to the standing of my claimed qualifications. I further acknowledge that the Institution reserves the right to vary or reverse any decision regarding admission made on the basis of incorrect or incomplete information and that should the information be found false at any stage, the scholarship will be terminated immediately and I will be liable to re-pay the Institution the total sum of any payments already received.
                </li>
              { conf.ADDDITIONAL_DECLARATIONS.search(app.scholarshipChosen) > 0 ? <AddDeclaration/> : ''}
              </ol>
              </Form.Text>
          </Form.Group>
        </Col>
      </Form.Row>
   
      </>
    );
}